import { render, staticRenderFns } from "./DocumentosNormativos.vue?vue&type=template&id=e87b553e"
import script from "./DocumentosNormativos.vue?vue&type=script&lang=js"
export * from "./DocumentosNormativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports